import { INPUT_TYPE } from "../../../human-organization/summary-employee-request/constant";
import { department } from "../../../info-technology-process/data";

export const eContent = {
  productName: "productName", // tên sản phẩm
  Dram: "Dram", // đơn vị tính
  requestedQuantity: "requestedQuantity", //số lượng yêu cầu
  inventoryQuantity: "inventoryQuantity", ////số lượng tồn tại
  productLifetime: "productLifetime", //thời gian sử dụng
  note: "note", //ghi chú
  approvedQuantity: "approvedQuantity", //số lượng xét duyệt
};


export const formFields1 = [
  {
    type: INPUT_TYPE.SELECT,
    options: department,
    label: "Cơ quan/Đơn vị",
    require: true,
    field: "eDepartment",
    span: 12,
    placeholder: "Chọn Cơ quan/Đơn vị",
  }
];

export const formFields2 = [
  {
    type: INPUT_TYPE.TEXT,
    label: "Số điện thoại",
    require: true,
    field: "ePhoneNumber",
    span: 12,
    placeholder: "Nhập số điện thoại",
  }
];